/**
 * @generated SignedSource<<fd91769c20ba52ecd839b90a3ee7ee6b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespNullSearchResults_itemSearch$data = {
  readonly soldItems: {
    readonly totalResults: number | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespFollowSearchBanner_itemSearch" | "SbSharedControlledHeadingWrapper_itemSearch" | "SbSharedNullSearchRelatedItems_itemSearch" | "SbSharedTitle_itemSearch" | "SharedFollowSearchBanner_itemSearch" | "SharedFollowSearchProvider_itemSearch" | "SharedFollowTopButton_itemSearch" | "SharedRecentSales_itemSearch" | "SharedYMAL_itemSearch">;
  readonly " $fragmentType": "SbRespNullSearchResults_itemSearch";
};
export type SbRespNullSearchResults_itemSearch$key = {
  readonly " $data"?: SbRespNullSearchResults_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespNullSearchResults_itemSearch">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "priceBookName"
    },
    {
      "kind": "RootArgument",
      "name": "userCountryCode"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespNullSearchResults_itemSearch",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedFollowSearchProvider_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedNullSearchRelatedItems_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespFollowSearchBanner_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedFollowSearchBanner_itemSearch"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "priceBookName",
          "variableName": "priceBookName"
        },
        {
          "kind": "Variable",
          "name": "userCountryCode",
          "variableName": "userCountryCode"
        }
      ],
      "kind": "FragmentSpread",
      "name": "SharedYMAL_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedFollowTopButton_itemSearch"
    },
    {
      "alias": "soldItems",
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 28
        }
      ],
      "concreteType": "soldResultsConnection",
      "kind": "LinkedField",
      "name": "soldResults",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalResults",
          "storageKey": null
        }
      ],
      "storageKey": "soldResults(first:28)"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedRecentSales_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedTitle_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedControlledHeadingWrapper_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "e62b7fdb598b75b4dd6626dc432472d7";

export default node;
